module.exports = __webpack_public_path__ + "static/media/icon-header-blanc.744d63dc.png";